import React, {useState} from 'react';
import {CONTENT_DASHBOARD_TABS_LIST, DEFAULT_CONTENT_DASHBOARD_TAB} from "../../constants/content.constant";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import PromptsList from "../prompt/prompts-list";
import BlogsList from "../blog-post/blog-posts-list";

const tabsList = CONTENT_DASHBOARD_TABS_LIST;

const ContentDashboard = () => {
    const [selectedTab, setSelectedTab] = useState(DEFAULT_CONTENT_DASHBOARD_TAB);

    return (
        <>

            <div className="page-container">

                <div className="items-center justify-start p-4 w-full">
                    <div className="flex justify-start m-2 pb-2">
                        <div className="text-xl">
                            Content
                        </div>
                    </div>

                    <div className="justify-center">

                        <div className="justify-start px-4 py-2">

                            <div>
                                <ShowTabsList
                                    setSelectedTab={setSelectedTab}
                                    selectedTab={selectedTab}
                                    tabsList={tabsList}/>
                            </div>

                            <div className="mt-4 px-4">

                                {selectedTab?.key === 'prompts' &&
                                    <div>
                                        <PromptsList/>
                                    </div>
                                }

                                {selectedTab?.key === 'blog-posts' &&
                                    <div>
                                        <BlogsList/>
                                    </div>
                                }

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </>
    )
}

export default ContentDashboard
